import { render, staticRenderFns } from "./ButtonApprove.vue?vue&type=template&id=3f075682&"
import script from "./ButtonApprove.vue?vue&type=script&lang=js&"
export * from "./ButtonApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports